// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ochZ","select":"styles_select__2K6Uy"};